import React from 'react';
import { MainLayout } from '~/layouts/web';

import { DietSettingsScreenContent } from './DietSettingsScreen.native';

export const DietSettingsScreen = () => {
    return <MainLayout title="Ustawienia diety" scrollable={false} fullWidth content={<DietSettingsScreenContent />} />;
};
